export default __webpack_public_path__ + "static/media/aboutimg.e39e2a32.png";